import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import type { UserRole } from "@/types/database.types";

type FinancePermissions = {
  role: UserRole | null | undefined;
  isLoading: boolean;
  canUpdateBalance: boolean;
  roleLabel: string; // удобно для UI в шапке
};

export function useFinancePermissions(): FinancePermissions {
  const { user: profile, loading: isLoading } = useAuth();

  const role = profile?.role ?? null;

  const canUpdateBalance = useMemo(() => {
    return role === "finance" || role === "admin";
  }, [role]);

  const roleLabel = useMemo(() => {
    if (isLoading) return "Loading...";
    return role ?? "unknown";
  }, [isLoading, role]);

  return { role, isLoading, canUpdateBalance, roleLabel };
}